import React from 'react';
import logo2 from '../images/logo2.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-wrapper">
        <div className="footer-content">
        {/* Logo and Company Info */}
        <div className="footer-logo">
          <div className="logo-container">
            <img src={logo2} alt="Encardio Rite Logo" className="footer-logo-image" />
          </div>
        </div>

        {/* Navigation Columns */}
        <div className="footer-navigation">
          <div className="nav-column">
            <h3>Home</h3>
            <ul>
              <li><a href="https://www.encardio.com/contact" className="footer-link">Contact</a></li>
            </ul>
          </div>

          <div className="nav-column">
            <h3>Products</h3>
            <ul>
              <li><a href="https://www.encardio.com/geotechnical-products" className="footer-link">Sensors</a></li>
              <li><a href="https://www.encardio.com/geotechnical-products/data-loggers" className="footer-link">Dataloggers</a></li>
              <li><a href="https://www.proqio.com/?_gl=1*x3rfzr*_gcl_au*MTA0ODMzMzE0NC4xNzU5NzMxODYz" className="footer-link">Infrastructure Data Intelligence Platform</a></li>
            </ul>
          </div>

          <div className="nav-column">
            <h3>Applications</h3>
            <ul>
              <li><a href="https://www.encardio.com/bridge-monitoring" className="footer-link">Bridge Monitoring</a></li>
              <li><a href="https://www.encardio.com/landslide-monitoring" className="footer-link">Landslide Monitoring</a></li>
              <li><a href="https://www.encardio.com/soil-consolidation" className="footer-link">Soil Consolidation</a></li>
              <li><a href="https://www.encardio.com/dam-monitoring" className="footer-link">Dam Monitoring</a></li>
              <li><a href="https://www.encardio.com/mines-monitoring" className="footer-link">Mines Monitoring</a></li>
              <li><a href="https://www.encardio.com/structural-health-monitoring" className="footer-link">Structural Monitoring</a></li>
              <li><a href="https://www.encardio.com/nuclear-power-plant" className="footer-link">Nuclear Power Plant</a></li>
              <li><a href="https://www.encardio.com/tunnel-monitoring" className="footer-link">Tunnel Monitoring</a></li>
              <li><a href="https://www.encardio.com/groundwater-monitoring" className="footer-link">Groundwater Monitoring</a></li>
              <li><a href="https://www.encardio.com/wind-turbine-monitoring" className="footer-link">Wind Turbine Monitoring</a></li>
              <li><a href="https://www.encardio.com/deep-excavation-monitoring" className="footer-link">Deep Excavation Monitoring</a></li>
            </ul>
          </div>

          <div className="nav-column">
            <h3>Resources</h3>
            <ul>
              <li><a href="https://www.encardio.com/downloads" className="footer-link">Downloads</a></li>
              <li><a href="https://www.encardio.com/news-and-event" className="footer-link">News And Event</a></li>
              <li><a href="https://www.encardio.com/case-studies" className="footer-link">Case Study</a></li>
              <li><a href="https://www.encardio.com/blog" className="footer-link">Blog</a></li>
              <li><a href="https://www.encardio.com/certifications" className="footer-link">Certifications</a></li>
            </ul>
          </div>

          <div className="nav-column">
            <h3>Policies</h3>
            <ul>
              <li><a href="https://www.encardio.com/privacy-policies" className="footer-link">Privacy Policies</a></li>
              <li><a href="https://www.encardio.com/legal-policies" className="footer-link">Legal Policies</a></li>
              <li><a href="https://www.encardio.com/terms-of-use" className="footer-link">Terms Of Use</a></li>
              <li><a href="https://www.encardio.com/standard-terms-condition" className="footer-link">Standard Terms And Conditions</a></li>
              <li><a href="https://www.encardio.com/cookies" className="footer-link">Cookies</a></li>
            </ul>
          </div>

          <div className="nav-column">
            <h3>Project</h3>
            <ul>
              <li><a href="https://www.encardio.com/projects/infrastructure-health-monitoring" className="footer-link">Infrastructure, Heritage</a></li>
              <li><a href="https://www.encardio.com/projects/metro-tunnels" className="footer-link">Metro Tunnels</a></li>
              <li><a href="https://www.encardio.com/projects/rail-road-tunnels" className="footer-link">Rail/Road Tunnels</a></li>
              <li><a href="https://www.encardio.com/projects/sewer-tunnels" className="footer-link">Sewer Tunnels</a></li>
              <li><a href="https://www.encardio.com/projects/dams" className="footer-link">Dams</a></li>
              <li><a href="https://www.encardio.com/projects/mines-nuclear-power-plant" className="footer-link">Mines, Nuclear Power Plant</a></li>
              <li><a href="https://www.encardio.com/projects/deep-excavations-foundations" className="footer-link">High-Rise, Deep-Excavations</a></li>
              <li><a href="https://www.encardio.com/projects/bridges" className="footer-link">Bridges, Highways, Rails</a></li>
              <li><a href="https://www.encardio.com/projects/slope-stabilization-ground-improvement" className="footer-link">Slope Stabilization, Ground Improvement</a></li>
            </ul>
          </div>
        </div>
        </div>
      </div>

      {/* Separator Line */}
      <div className="footer-separator"></div>

      {/* Social Media and Copyright */}
      <div className="footer-bottom">
        <div className="social-media">
          <a target="_blank" rel="noreferrer" href="https://www.instagram.com/encardiorite/">
            <img src="https://www.encardio.com/assets/images/footer/instagram.svg" alt="instagram" />
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/encardio-rite-electronics-pvt.-ltd">
            <img src="https://www.encardio.com/assets/images/footer/linkedin.svg" alt="linkedin" />
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.facebook.com/EncardioRiteGroup">
            <img src="https://www.encardio.com/assets/images/footer/facebook.svg" alt="facebook" />
          </a>
          <a target="_blank" rel="noreferrer" href="https://twitter.com/encardio_rite">
            <img src="https://www.encardio.com/assets/images/footer/twitter.svg" alt="twitter" />
          </a>
          <div className="iconImg">
            <a target="_blank" rel="noreferrer" href="https://www.youtube.com/encardioritegroup">

              <img src="https://www.encardio.com/assets/images/footer/youtube.png" alt="youtube" />
            </a>
          </div>
        </div>

        <div className="copyright">
          <p>©Copyright 1966-2025 Encardio Rite. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
